import { CardContent, CardHeader, Stack } from "@mui/material"
import DashboardLayout from "../../../layoutcontainers/DashboardLayout"
import MaterialTypography from "../../../components/MaterialTypography"
import MaterialButton from "../../../components/MaterialButton"
import { FileUpload, FilterAlt } from "@mui/icons-material"
import AddIcon from '@mui/icons-material/Add';
import Table from "../../../components/Table"
import { useNavigate } from "react-router-dom"
import { useEffect, useState } from "react"
import { deleteData, fetchData, postData } from "../../../services"
import { setCurrentPage, setRowsPerPage, setTotalPages } from "./store/index";
import { useDispatch, useSelector } from "react-redux"
import UploadFile from "../../Utils/UploadFile"
import { useSnackbar } from "../../../context/popup"
import { useLoading } from "../../../components/Loading"
import BankListFilterDialog from "./components/BankListFilterDialog.js";

const BankNameList = () => {

    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { showSnackbar } = useSnackbar();
    const { setCircleLoading } = useLoading();

    const currentPage = useSelector((state) => state?.generalBankStore?.currentPage);
    const rowsPerPage = useSelector((state) => state?.generalBankStore?.rowsPerPage);
    const totalPages = useSelector((state) => state?.generalBankStore?.totalPages);

    const [bankNameList, setBankNameList] = useState([]);
    const [isRefresh, setIsRefresh] = useState(false);
    const [openUploadFileDialog, setOpenUploadFileDialog] = useState(false);
    const [fileUploading, setFileUploading] = useState(false);
    const [uploadSuccess, setUploadSuccess] = useState(false);
    const [clearFileOnSuccess, setClearFileOnSuccess] = useState(false);
    const [search, setSearch] = useState("");
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [filterData, setFilterData] = useState({
        isActive: "",
    });

    useEffect(() => {
        fetchBankNameList();
    },[isRefresh,currentPage, rowsPerPage, search])
    
    //API List
    const fetchBankNameList = async () => {
        setCircleLoading(true);
        try {
         let url = `/reference/general/bank?page=${currentPage}&limit=${rowsPerPage}&searchTerm=${search}`;
                    
        //for active and inactive status
        if(filterData.isActive !== "") {
            url += `&isActive=${filterData.isActive}`;
        }

        const response = await fetchData(url);
        
        if(response?.success){
            setBankNameList(response?.data?.items)
            dispatch(setTotalPages(response?.data?.totalPages));
        }
        else{
            showSnackbar("Error Fetching Bank Data","error");
        }
        } 
        catch (error) {
            console.error('Error Fetching States:', error);
            showSnackbar(error?.response?.data?.message || 'Network Error', "error");
        }
        finally{
            setCircleLoading(false);
        }
    }
    
    //bulk file upload api function
    const handleFileUploadSuccess = async (file) => {
        setFileUploading(true)
        setUploadSuccess(false)

        try {
            const formData = new FormData()

            formData.append('file', file)

            const result = await postData(`/reference/master/bulkUpload/general-bank`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });        

            if (result?.success) {
                setUploadSuccess(true)
                showSnackbar(result?.message,"success");
                setOpenUploadFileDialog(false);
                setClearFileOnSuccess(true);
                fetchBankNameList(); 
            }
            else {
                setUploadSuccess(false);
                showSnackbar('Faiiled to upload file', "error")
            }

        } catch (error) {
            const errorMessage = error?.response?.data?.message;                
            console.error('Upload error:', error || errorMessage)
            showSnackbar(errorMessage || "Network Error", "error")
        } 
        finally {
                setFileUploading(false)
        }
    };

    //delete api function
    const handleDelete = async (row) => {
        try{
            const response = await deleteData(`/reference/general/bank-delete`, {ids:[row?.id]});
            setIsRefresh(!isRefresh);      
            const responseMessage = response?.message;
            if(response?.success){
                showSnackbar(responseMessage, "success");
            }
            else{
                showSnackbar(responseMessage, "error");
            }
        } 
        catch(error) {
            console.error("Error deleting data:", error);
            showSnackbar(error?.response?.data?.message || "Network Error", "error");
        }
    };

    //table mapping
    const bankNameListTable = {
        columns: [
            { key: "sno", label: "S.No.", renderCell: (row) => row.sno },
            { key: "name", label: "Bank Name", renderCell: (row) => row.name },
            { key: "createdAt", label: "Created At", renderCell: (row) => row.createdAt },
            {
                key: "isActive",
                label: "Status",
                renderCell: (row) => (
                    <span>
                    {row.isActive ? (
                        <span style={{ color: "green", fontWeight: "bold" }}>Active</span>
                    ) : (
                        <span style={{ color: "red", fontWeight: "bold" }}>Inactive</span>
                    )}
                    </span>
                )
            },
        ],

        rows: bankNameList?.map((bank, index) => ({
            id: bank?.id,
            sno: index + 1,
            name: bank?.name || "",
            isActive: bank?.isActive,
            createdAt: bank?.createdAt
            ? new Date(bank.createdAt).toLocaleDateString("en-GB", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                })
            : "",
        })),
    };

    const actions = {
        edit: true,
        view: true,
        delete: true,

        onEdit: (row) => {
            navigate(`/general-master/bank-list/bank-details?pageType=edit&id=${row.id}`);
        },
        onView: (row) => {
            navigate(`/general-master/bank-list/bank-details?pageType=view&id=${row.id}`);
        },
        onDelete: (row) => handleDelete(row),
    };

    const handlePaginationChange = (page) => {
        dispatch(setCurrentPage(page));
    };

    const handleRowsPerPageChange = (rowsPerPage) => {
        dispatch(setRowsPerPage(rowsPerPage));
        dispatch(setCurrentPage(1));
    };

    const handleAddNewBankName = () => {
        navigate("/general-master/bank-list/bank-details");
    };

    const handleSearch = (value) => {
        setSearch(value);
    };


  return (
    <DashboardLayout>
        <CardHeader
        title={(
            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
                spacing={2}
            >
                <Stack direction="column" spacing={0}>
                    <MaterialTypography variant="h5" fontWeight="medium">
                        Bank List
                    </MaterialTypography>
                    <MaterialTypography variant="caption" color="text">
                        List of available Bank Names.
                    </MaterialTypography>
                </Stack>
                <Stack direction="row" spacing={1}>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FilterAlt/>}
                    onClick={(event) => setAnchorEl(event.currentTarget)}
    
                    >
                    Filter
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<FileUpload/>}
                    onClick={() => setOpenUploadFileDialog(true)}>
                        Bulk Upload
                    </MaterialButton>
                    <MaterialButton
                    variant="gradient"
                    color="dark"
                    size="small"
                    startIcon={<AddIcon />}
                    onClick={() => handleAddNewBankName()}
                    >
                        Bank
                    </MaterialButton>
                </Stack>
            </Stack>
        )} 
        />
        <CardContent>
            <Table
            columns={bankNameListTable?.columns}
            data={bankNameListTable?.rows}
            actions={actions}
            pagination={{
                totalPages,
                currentPage,
                onPageChange: (page) => handlePaginationChange(page),
                rowsPerPage,
                onRowsPerPageChange: (rowsPerPage) => handleRowsPerPageChange(rowsPerPage),
                rowsPerPageOptions: [5, 10, 15, 20],
            }}
            getRowKey={(row) => row.id}
            className="custom-table"
            noDataLabel="No Banks found"
            handleSearch={handleSearch}
            />            
        </CardContent>
        <UploadFile
        open={openUploadFileDialog}
        setOpen={setOpenUploadFileDialog}
        onUploadSuccess={handleFileUploadSuccess}
        fileTypes={['csv', 'xlsx']}
        fileUploading={fileUploading}
        uploadSuccess={uploadSuccess}
        setUploadSuccess={setUploadSuccess}
        setFileUploading={setFileUploading}
        clearFileOnSuccess={clearFileOnSuccess}
        />
        <BankListFilterDialog
        anchorEl={anchorEl}
        open={open}
        onClose={() => setAnchorEl(null)}
        filterData={filterData}
        setFilterData={setFilterData}
        onApply={() => {
            setAnchorEl(null);   // close popup
            fetchBankNameList();  // call API after filter applied
        }}
        />
    </DashboardLayout>
  )
}

export default BankNameList